import { useMutation } from "@tanstack/react-query";
import type { User } from "@packsize/identity-api-sdk";
import { useIdentityClient } from "@packsize/authentication";

import { queryClient } from "@/lib/query-client";

import { COMPANY_USERS_QUERY_KEY, USERS_QUERY_KEY } from "./use-users";

export const useDeleteUser = () => {
	const { client } = useIdentityClient();

	return useMutation({
		mutationFn: async (user: User) => {
			const result = await client.removeUser(user.id);

			if (result.success === false) {
				throw new Error("Failed to delete user");
			}

			return result;
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: [USERS_QUERY_KEY] });
			await queryClient.invalidateQueries({ queryKey: [COMPANY_USERS_QUERY_KEY] });
		},
	});
};
